import { render, staticRenderFns } from "./UserDashboardSubscriptions.vue?vue&type=template&id=13f05f7d&scoped=true&"
import script from "./UserDashboardSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserDashboardSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f05f7d",
  null
  
)

export default component.exports